import styles from "./index.module.css";
import Questions from "../Questions"; // Імпортуємо стилі
import ProgressBar from "@ramonak/react-progress-bar";
import SignOut from "./SignOut";
import q from "./questions.json";
import { use, useEffect, useState } from "react";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../store/UserStore/context";
import getLevelInfo from "../../IntesivePage/helpers";
import { isTestUser } from "../../../testUser";
import ConfirmExit from "./ConfirmExit";
import { apiUrl } from "../../../config";

function getEnglishLevel(score) {
  if (score < 0 || score > 40) {
    return "Неприпустиме значення";
  }
  if (score <= 5) return "A1";
  if (score <= 10) return "A2";
  if (score <= 17) return "B1";
  if (score <= 24) return "B1+";
  if (score <= 30) return "B2";
  if (score <= 34) return "B2+";
  return "C1";
}

const levels = {
  A1: "Beginner",
  A2: "Elementary",
  B1: "Intermediate",
  "B1+": "Intermediate",
  B2: "Upper Intermediate",
  C1: "Advanced",
  C2: "Proficient",
};

export default function UserTest() {
  const navigate = useNavigate();
  const userStore = use(UserContext);
  const [counter, setCounter] = useState(1);
  const [userScore, setUserScore] = useState(0);
  const { key } = getLevelInfo(userScore);
  const closed = false;
  const [confirmExit, setConfirmExit] = useState(false);
  const testInProgress = counter <= 40;

  // Test answers live in component state only, so leaving the page loses them.
  useEffect(() => {
    if (!testInProgress) return;
    const onBeforeUnload = (event) => {
      event.preventDefault();
      // Legacy browsers need a non-empty returnValue to show their own prompt.
      event.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [testInProgress]);
  return (
    <>
      {counter > 40 ? (
        <div className={styles.resultContainer}>
          <h2>
            Твій результат
            <br />
            <span>{getEnglishLevel(userScore)}</span>
          </h2>
          <div className={styles.level}>
            {levels[getEnglishLevel(userScore)]}
          </div>
          <div className={styles.text}>
            {closed ? (
              <div>
                <div>
                  На жаль, місць в групу цього рівня на інтенсиві не лишилось.
                </div>
                <div>Обирай викладача та записуйся на регулярні заняття!</div>
              </div>
            ) : userScore > 41 ? (
              "Ти досяг максимального рівня у вивченні англійської, але якщо ви відчуваєте, що готові повторити програму B2-C1, то з радістю повторимо її разом на інтенсиві!"
            ) : (
              "Чекаємо тебе на інтенсиві!"
            )}
          </div>
          <div className={styles.continue}>
            {closed ? (
              <FakeButton
                onClick={async () => {
                  await fetch(apiUrl("/api/intensive/test-result"), {
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                    credentials: "include",
                    method: "post",
                    body: JSON.stringify({
                      email: userStore.store.user.email,
                      testResult: userScore,
                    }),
                  });
                  window.location =
                    "https://profound-english.community/teachers/";
                }}
              >
                Обрати викладача
              </FakeButton>
            ) : (
              <FakeButton
                onClick={async () => {
                  // Shared test account — skip the POST, see src/testUser.js
                  if (isTestUser(userStore.store.user)) {
                    document.body.style.backgroundColor = "#0A2294";
                    userStore.actions.setUser({
                      ...userStore.store.user,
                      testResult: userScore,
                    });
                    navigate("/payment");
                    return;
                  }
                  const postres = await fetch(
                    apiUrl("/api/intensive/test-result"),
                    {
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                      },
                      credentials: "include",
                      method: "post",
                      body: JSON.stringify({
                        email: userStore.store.user.email,
                        testResult: userScore,
                      }),
                    },
                  );
                  if (postres.ok) {
                    document.body.style.backgroundColor = "#0A2294";

                    userStore.actions.setUser({
                      ...userStore.store.user,
                      testResult: userScore,
                    });
                    navigate("/payment");
                  }
                }}
                className={styles.continueButton}
                red
              >
                Продовжити
              </FakeButton>
            )}
          </div>
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.progress}>
            <div className={styles.count}>{counter} з 40</div>
            <ProgressBar
              completed={(counter / 40) * 100}
              height={10}
              bgColor={"#FD3B7A"}
              baseBgColor={"#FFC6CD"}
              isLabelVisible={false}
              className={styles.progressBar}
            />
            <div
              className={styles.abandonTest}
              onClick={() => setConfirmExit(true)}
            >
              <div className={styles.exit}>Вийти</div>
              <SignOut />
            </div>
          </div>
          <div className={styles.question}>Обери правильну відповідь</div>
          <Questions
            {...q[counter - 1]}
            nextScreen={({ isCorrect }) => {
              if (isCorrect) {
                setUserScore(userScore + 1);
              }
              setCounter(counter + 1);
            }}
            counter={counter}
          />
          {confirmExit && <ConfirmExit close={() => setConfirmExit(false)} />}
        </div>
      )}
    </>
  );
}
